import React from "react";
import { MDSProgressBar } from "@/mds";
import { motion, AnimatePresence } from "motion/react";
import styled from "@emotion/styled";

type Props = {
  isPaused: boolean;
  durationMs: number;
  onComplete: () => void;
};

export const MDSSessionCountdownTimer: React.FC<Props> = ({ isPaused, durationMs, onComplete }) => {
  return (
    <ProgressContainer>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
        >
          <MDSProgressBar
            aria-label="Saving to Mem"
            color="primary"
            animation={{
              direction: "decrease",
              duration: durationMs,
              paused: isPaused,
              onComplete: onComplete,
            }}
          />
        </motion.div>
      </AnimatePresence>
    </ProgressContainer>
  );
};

const ProgressContainer = styled.div`
  position: absolute;
  top: -8px;
  left: 0;
  width: 100%;
  height: 10px;
  z-index: 10;
`;
